import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, EmissaoAtestadoPainelLiberacaoNormal } from './types';

export const INITIAL_STATE: EmissaoAtestadoPainelLiberacaoNormal = {
	status: 0,
	data: { pdfBase64: '' },
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EmissaoAtestadoPainelLiberacaoNormal {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMISSAO_ATESTADO_PAINEL_REQUEST: {
				break;
			}

			case Types.EMISSAO_ATESTADO_PAINEL_SUCCESS: {
				draft.status = 200;
				draft.data.pdfBase64 = action.payload.pdfBase64;
				break;
			}

			case Types.EMISSAO_ATESTADO_PAINEL_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMISSAO_ATESTADO_PAINEL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}

		return draft;
	});
}
